import { useAppDisplayModeContext } from '@archipro-design/aria';
import LatestArticlesDesktop from '../latest-articles/LatestArticles.desktop';
import type { TileProps } from '../../type';
import FilmsSectionMobile from './FilmsSection.mobile';

interface LatestArticlesProps {
    latestArticles: TileProps[];
    loadMoreLink?: string;
}

const FilmsSection = ({
    latestArticles,
    loadMoreLink,
}: LatestArticlesProps) => {
    const { mobile: isMobile } = useAppDisplayModeContext();
    const title = isMobile ? 'Films ' : 'Latest Films';

    return (
        <>
            {isMobile ? (
                <FilmsSectionMobile
                    title={title}
                    latestArticles={latestArticles}
                />
            ) : (
                <LatestArticlesDesktop
                    title={title}
                    latestArticles={latestArticles}
                    loadMoreLink={loadMoreLink}
                    useFilmsLayout={true}
                />
            )}
        </>
    );
};

export default FilmsSection;
